<script lang="ts">
    import ArrowRight from "../icons/ArrowRightIcon.svelte";
    import IconImg from "./IconImg.svelte";
    import { link } from "svelte-spa-router";
    import Plus from "../icons/PlusIcon.svelte";
    import { url } from "@roxi/routify";
    import PdfIcon from "../icons/PdfIcon.svelte";
    import Visibility from "./Visibility.svelte";
    import { fade } from "svelte/transition";
    import CloseIcon from "../icons/CloseIcon.svelte";

    export let yellow: Boolean = false;
    export let blue: Boolean = false;
    export let arrow: Boolean = false;
    export let arrow_left: boolean = false;
    export let pdf: boolean = false;
    export let plus: Boolean = false;
    export let close: Boolean = false;
    export let notupper: Boolean = false;
    export let href: string = "javascript:void(0)";
    export let newtab: boolean = false;
    export let small: boolean = false;
    export let size: string = "";
    export let blinking: boolean = false;
    export let padding: string = "1em 2em";
    export let icon_left: boolean = false;

    const target =
        newtab || href.match(/\.(pdf|jpg|jpeg|png|exe)/) ? "_blank" : "";
</script>

<a
    {href}
    {target}
    class:yellow
    class:blue
    class:notupper
    class:plus
    class="btn"
    class:small
    style="--size: {size}; --padding: {padding}"
    class:size
    class:blinking
    on:click
>
    {#if icon_left}
        {#if arrow}
            <IconImg svg={ArrowRight} />
        {:else if arrow_left}
            <IconImg svg={ArrowRight} mirrorx />
        {:else if pdf}
            <IconImg svg={PdfIcon} />
        {:else if close}
            <IconImg svg={CloseIcon} />
        {/if}
        <slot />
    {:else}
        {#if plus}
            <div class="plus-icon">
                <Plus />
            </div>
        {/if}
        <slot />
        {#if arrow}
            <IconImg svg={ArrowRight} />
        {:else if arrow_left}
            <IconImg svg={ArrowRight} mirrorx />
        {:else if pdf}
            <IconImg svg={PdfIcon} />
        {:else if close}
            <IconImg svg={CloseIcon} />
        {/if}
    {/if}
</a>

<style lang="scss">
    @import "./src/vars";

    * {
        color: white;
    }
    a {
        display: inline-flex;
        align-items: center;
        border: none;
        outline: none;
        background-color: $green;
        padding: var(--padding);
        margin-right: 0.5em;
        margin-bottom: 0.5em;
        margin-top: 0.5em;
        border-radius: 2em;
        transition:
            transform 0.4s,
            font-size 0.4s;
        cursor: pointer;
        text-transform: uppercase;
        gap: 1em;
        @media (max-width: 800px) {
            font-size: 0.8em;
        }
        & :global(.icon-wrapper) {
            transform: scale(1.25);
        }
        &.small {
            font-size: 0.75em;
        }
        &.size {
            font-size: var(--size);
        }
        &.yellow {
            background-color: $yellow;
            color: $grayDark;
        }
        &.blue {
            background-color: $blue;
        }
        &.plus {
            background-color: transparent;
            color: $gray;
            padding: 0;
            align-items: center;
            &:hover {
                transform: scale(1) !important;
            }
        }
        .plus-icon {
            margin-right: 1em;
            :global(svg) {
                padding: 0.8em;
                color: white;
                fill: white;
                background-color: $green;
                width: 3em;
                height: 3em;
                border-radius: 1000px;
            }
        }
        &.blinking {
            animation: blinking 1s infinite forwards;
        }

        &:active,
        &:hover {
            transform: scale(1.1) !important;
        }
        &.notupper {
            text-transform: unset;
        }
    }
</style>
